import { useState } from 'react';

function americanToDecimal(american) {
	const a = parseFloat(american);
	if (isNaN(a) || a === 0) return NaN;
	if (a > -100 && a < 100) return NaN;
	if (a > 0) return a / 100 + 1;
	return 100 / Math.abs(a) + 1;
}

export const HedgeCalculator = () => {
	const [originalOdds, setOriginalOdds] = useState('');
	const [originalStake, setOriginalStake] = useState('');
	const [hedgeOdds, setHedgeOdds] = useState('');

	const origDec = americanToDecimal(originalOdds);
	const hedgeDec = americanToDecimal(hedgeOdds);
	const stakeNum = parseFloat(originalStake);

	const hasResults = !isNaN(origDec) && origDec > 1 && !isNaN(hedgeDec) && hedgeDec > 1 && !isNaN(stakeNum) && stakeNum > 0;

	let results = null;
	if (hasResults) {
		const originalPayout = stakeNum * origDec;
		const hedgeStake = originalPayout / hedgeDec;
		const profitIfOriginalWins = originalPayout - stakeNum - hedgeStake;
		const profitIfHedgeWins = (hedgeStake * hedgeDec) - stakeNum - hedgeStake;
		const guaranteedProfit = Math.min(profitIfOriginalWins, profitIfHedgeWins);

		results = {
			hedgeStake,
			profitIfOriginalWins,
			profitIfHedgeWins,
			guaranteedProfit,
			originalPayout,
		};
	}

	const handleReset = () => {
		setOriginalOdds('');
		setOriginalStake('');
		setHedgeOdds('');
	};

	return (
		<div>
			<div className="calc-section">
				<h3 className="calc-section-title">Original Bet</h3>
				<div className="calc-grid calc-grid-2">
					<div className="calc-input-group">
						<label className="calc-label">Original Odds (American)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="+300"
							value={originalOdds}
							onChange={(e) => setOriginalOdds(e.target.value)}
						/>
					</div>
					<div className="calc-input-group">
						<label className="calc-label">Original Stake ($)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="100"
							value={originalStake}
							onChange={(e) => setOriginalStake(e.target.value)}
						/>
					</div>
				</div>
			</div>

			<div className="calc-section">
				<h3 className="calc-section-title">Hedge Bet</h3>
				<div className="calc-input-group" style={{ maxWidth: '300px' }}>
					<label className="calc-label">Hedge Odds (American)</label>
					<input
						className="calc-input"
						type="text"
						placeholder="-150"
						value={hedgeOdds}
						onChange={(e) => setHedgeOdds(e.target.value)}
					/>
				</div>
			</div>

			{results && (
				<div className="calc-results">
					<h4 className="calc-results-title">Hedge Results</h4>
					<div className="calc-result-row">
						<span className="calc-result-label">Hedge Stake (Equal Profit)</span>
						<span className="calc-result-value highlight">${results.hedgeStake.toFixed(2)}</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Original Bet Payout</span>
						<span className="calc-result-value">${results.originalPayout.toFixed(2)}</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Profit if Original Wins</span>
						<span className={`calc-result-value ${results.profitIfOriginalWins >= 0 ? 'positive' : 'negative'}`}>
							{results.profitIfOriginalWins >= 0 ? '+' : ''}${results.profitIfOriginalWins.toFixed(2)}
						</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Profit if Hedge Wins</span>
						<span className={`calc-result-value ${results.profitIfHedgeWins >= 0 ? 'positive' : 'negative'}`}>
							{results.profitIfHedgeWins >= 0 ? '+' : ''}${results.profitIfHedgeWins.toFixed(2)}
						</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Guaranteed Profit</span>
						<span className={`calc-result-value ${results.guaranteedProfit >= 0 ? 'positive' : 'negative'}`}>
							{results.guaranteedProfit >= 0 ? '+' : ''}${results.guaranteedProfit.toFixed(2)}
						</span>
					</div>
				</div>
			)}

			<button className="calc-reset-btn" onClick={handleReset}>Reset</button>
		</div>
	);
};
